import { Injectable } from '@angular/core';
import { CustomToastService } from './custom-toast.service';
import { setCustomToastService } from '../helpers/show-toast';

@Injectable({
  providedIn: 'root'
})
export class ToastrWrapperService {
  constructor(private customToastService: CustomToastService) {
    // Set the global reference so showNotification can use it
    setCustomToastService(this.customToastService);
  }

  success(message: string, title?: string, options?: any) {
    this.customToastService.success(message, title, options?.timeOut || 5000);
  }

  error(message: string, title?: string, options?: any) {
    this.customToastService.error(message, title, options?.timeOut || 5000);
  }

  warning(message: string, title?: string, options?: any) {
    this.customToastService.warning(message, title, options?.timeOut || 5000);
  }

  info(message: string, title?: string, options?: any) {
    this.customToastService.info(message, title, options?.timeOut || 5000);
  }

  show(message: string, title?: string, options?: any) {
    this.customToastService.info(message, title, options?.timeOut || 5000);
  }

  // Add any other methods that might be used
  clear() {
    this.customToastService.clear();
  }

  remove(id: string) {
    this.customToastService.remove(id);
  }
}
